import { createAction, handleActions } from 'redux-actions'
import { sendApiRequest } from 'utils/api'
import { getClientId } from 'utils/utils'

export const GET_NCE_REQUEST_COUNT = 'GET_NCE_REQUEST_COUNT'
export const getNceRequestCount = (search) => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_NCE_REQUEST_COUNT)())
    const clientId = getClientId(getState)
    const options = {
      clientId,
      where: {
        and: [
          { status: { inq: ['live', 'submitted'] } }
        ]
      }
    }
    if (search) {
      options.where.and.push(search)
    }
    sendApiRequest('NceRequests/count', {
      accessToken: getState().auth.account.accessToken
    }, 'get', options).then((response) => {
      if (response.status === 'failure') {
        dispatch(getNceRequestCountError(response))
      }
      if (response.status === 'success') {
        dispatch(getNceRequestCountSuccess(response.data.count))
      }
    })
  }
}

export const GET_NCE_REQUEST_COUNT_SUCCESS = 'GET_NCE_REQUEST_COUNT_SUCCESS'
export const getNceRequestCountSuccess = createAction(GET_NCE_REQUEST_COUNT_SUCCESS)

export const GET_NCE_REQUEST_COUNT_ERROR = 'GET_NCE_REQUEST_COUNT_ERROR'
export const getNceRequestCountError = createAction(GET_NCE_REQUEST_COUNT_ERROR)

export const GET_NCE_REQUESTS = 'GET_NCE_REQUESTS'
export const getNceRequests = (pageSize = 0, pageNumber = 1, search) => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_NCE_REQUESTS)())
    const clientId = getClientId(getState)
    const options = {
      clientId,
      filter: {
        where: {
          and: [
            { status: { inq: ['live', 'submitted'] } }
          ]
        },
        order: 'id DESC',
        limit: pageSize,
        skip: (pageNumber - 1) * pageSize
      }
    }
    if (search) {
      options.filter.where.and.push(search)
    }
    sendApiRequest('NceRequests', {
      accessToken: getState().auth.account.accessToken
    }, 'get', options).then((response) => {
      if (response.status === 'failure') {
        dispatch(getNceRequestsError(response))
      }
      if (response.status === 'success') {
        dispatch(getNceRequestsSuccess(response.data))
      }
    })
  }
}

export const GET_NCE_REQUESTS_SUCCESS = 'GET_NCE_REQUESTS_SUCCESS'
export const getNceRequestsSuccess = createAction(GET_NCE_REQUESTS_SUCCESS)

export const GET_NCE_REQUESTS_ERROR = 'GET_NCE_REQUESTS_ERROR'
export const getNceRequestsError = createAction(GET_NCE_REQUESTS_ERROR)

export const GET_NCE_REQUESTS_FOR_MAP = 'GET_NCE_REQUESTS_FOR_MAP'
export const getNceRequestsForMap = (expiring) => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_NCE_REQUESTS_FOR_MAP)())
    const clientId = getClientId(getState)
    let statuses = ['live', 'submitted', 'expiring']
    if (expiring === true) {
      statuses = ['expiring']
    }
    const options = {
      clientId,
      filter: {
        fields: {
          status: true,
          contractorId: true,
          id: true,
          latitude: true,
          longitude: true,
          reference: true,
          networkId: true,
          contractorCompanyName: true,
          contractorMobile: true,
          contractPrincipal: true
        },
        where: {
          and: [
            { status: { inq: statuses } },
            { latitude: { neq: null } },
            { longitude: { neq: null } }
          ]
        }
      }
    }
    sendApiRequest('NceRequests', {
      accessToken: getState().auth.account.accessToken
    }, 'get', options).then((response) => {
      if (response.status === 'failure') {
        dispatch(getNceRequestsForMapError(response))
      }
      if (response.status === 'success') {
        dispatch(getNceRequestsForMapSuccess(response.data))
      }
    })
  }
}

export const GET_NCE_REQUESTS_FOR_MAP_SUCCESS = 'GET_NCE_REQUESTS_FOR_MAP_SUCCESS'
export const getNceRequestsForMapSuccess = createAction(GET_NCE_REQUESTS_FOR_MAP_SUCCESS)

export const GET_NCE_REQUESTS_FOR_MAP_ERROR = 'GET_NCE_REQUESTS_FOR_MAP_ERROR'
export const getNceRequestsForMapError = createAction(GET_NCE_REQUESTS_FOR_MAP_ERROR)

export const GET_NCE_REPORT_BY_ID = 'GET_NCE_REPORT_BY_ID'
export const getNceReportById = (id) => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_NCE_REPORT_BY_ID)())
    sendApiRequest(`NceRequests/${id}`, {
      accessToken: getState().auth.account.accessToken
    }, 'get').then((response) => {
      if (response.status === 'failure') {
        dispatch(getNceReportByIdError(response))
      }
      if (response.status === 'success') {
        dispatch(getNceReportByIdSuccess(response.data))
      }
    })
  }
}

export const GET_NCE_REPORT_BY_ID_SUCCESS = 'GET_NCE_REPORT_BY_ID_SUCCESS'
export const getNceReportByIdSuccess = createAction(GET_NCE_REPORT_BY_ID_SUCCESS)

export const GET_NCE_REPORT_BY_ID_ERROR = 'GET_NCE_REPORT_BY_ID_ERROR'
export const getNceReportByIdError = createAction(GET_NCE_REPORT_BY_ID_ERROR)

export const GET_NCE_REPORT_BY_ID_RESET = 'GET_NCE_REPORT_BY_ID_RESET'
export const getNceReportByIdReset = createAction(GET_NCE_REPORT_BY_ID_RESET)

export const GET_NCE_REQUESTS_RESET = 'GET_NCE_REQUESTS_RESET'
export const getNceRequestsReset = createAction(GET_NCE_REQUESTS_RESET)

const initialState = {
  nceRequestCount: 0,
  isGettingNceRequests: false,
  hasGottenNceRequests: false,
  nceRequests: [],
  selectedNceReport: {},
  isGettingNceReport: false,
  hasGottenNceReport: false,
  getNceReportError: {},
  isGettingNceRequestsForMap: false,
  hasGottenNceRequestsForMap: false,
  nceRequestsForMap: [],
}

export default handleActions({

  [GET_NCE_REQUEST_COUNT_SUCCESS]: (state, { payload }) => ({
    ...state,
    nceRequestCount: payload
  }),

  [GET_NCE_REQUESTS]: (state) => ({
    ...state,
    isGettingNceRequests: true,
    hasGottenNceRequests: false
  }),

  [GET_NCE_REQUESTS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isGettingNceRequests: false,
      hasGottenNceRequests: true,
      nceRequests: payload
    }
  },

  [GET_NCE_REQUESTS_FOR_MAP]: (state) => ({
    ...state,
    isGettingNceRequestsForMap: true,
    hasGottenNceRequestsForMap: false,
    nceRequestsForMap: []
  }),

  [GET_NCE_REQUESTS_FOR_MAP_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isGettingNceRequestsForMap: false,
      hasGottenNceRequestsForMap: true,
      nceRequestsForMap: payload
    }
  },

  [GET_NCE_REQUESTS_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isGettingNceRequests: false,
      hasGottenNceRequests: false,
      nceRequestsError: payload
    }
  },

  [GET_NCE_REQUESTS_RESET]: (state) => ({
    ...state,
    isGettingNceRequests: false,
    hasGottenNceRequests: false,
    nceRequests: [],
    nceRequestsError: {},
    nceRequestCount: 0
  }),

  [GET_NCE_REPORT_BY_ID]: (state) => ({
    ...state,
    isGettingNceReport: true,
    hasGottenNceReport: false
  }),

  [GET_NCE_REPORT_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isGettingNceReport: false,
      hasGottenNceReport: true,
      selectedNceReport: payload
    }
  },

  [GET_NCE_REPORT_BY_ID_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isGettingNceReport: false,
      hasGottenNceReport: false,
      getNceReportError: payload
    }
  },
  [GET_NCE_REPORT_BY_ID_RESET]: (state) => ({
    ...state,
    isGettingNceReport: false,
    hasGottenNceReport: false,
    selectedNceReport: {}
  })

}, initialState)
